import {
  pluginDivider,
  pluginDividerViewer,
  pluginEmoji,
  pluginEmojiViewer,
  pluginGiphy,
  pluginGiphyViewer,
  pluginImage,
  pluginImageViewer,
  pluginLink,
  pluginLinkViewer,
  pluginVideo,
  pluginVideoViewer,
} from '@wix/ricos';

import application from '../../../../../../../.application.json';

export const biSettings = {
  platform: 'Livesite' as const,
  consumer: 'members-about-ooi',
  usage: 'About (preview)',
  containerId: application.appDefinitionId,
};

export const pluginsViewer = [
  pluginImageViewer({ disableExpand: true }),
  pluginVideoViewer(),
  pluginDividerViewer(),
  pluginGiphyViewer(),
  pluginEmojiViewer(),
  pluginLinkViewer(),
];

export const pluginsEditor = [
  pluginImage(),
  pluginVideo(),
  pluginDivider(),
  pluginGiphy(),
  pluginEmoji(),
  pluginLink(),
];
